export default "__VITE_ASSET__dAfPzpSb__"